import { Clues } from "./Mini";

export const across: Clues[] = [
  {
    clueNumber: 1,
    clue: "Central Daylight Time",
    index: [1, 3],
    answer: "CDT",
  },
  {
    clueNumber: 4,
    clue: "Hello, or goodbye, in Honolulu",
    index: [2, 2],
    answer: "ALOHA",
  },
  {
    clueNumber: 6,
    clue: "Clots",
    index: [3, 1],
    answer: "COAGULA",
  },
  {
    clueNumber: 8,
    clue: "Same number of games won as served",
    index: [4, 1],
    answer: "ONSERVE",
  },
  {
    clueNumber: 9,
    clue: "My friends (Fr.)",
    index: [5, 1],
    answer: "MESAMIS",
  },
  {
    clueNumber: 10,
    clue: "Type of wrap",
    index: [6, 2],
    answer: "SARAN",
  },
  {
    clueNumber: 11,
    clue: "Identification",
    index: [7, 3],
    answer: "SSN",
  },
];

export const down: Clues[] = [
  {
    clueNumber: 1,
    clue: "Types of shares",
    index: [1, 3],
    answer: "CLASSAS",
  },
  {
    clueNumber: 2,
    clue: "Marks a book",
    index: [1, 4],
    answer: "DOGEARS",
  },
  {
    clueNumber: 3,
    clue: "Uma ______",
    index: [1, 5],
    answer: "THURMAN",
  },
  {
    clueNumber: 4,
    clue: "Top conditions",
    index: [2, 2],
    answer: "AONES",
  },
  {
    clueNumber: 5,
    clue: "Titular chipmunk in a movie",
    index: [2, 6],
    answer: "ALVIN",
  },
  {
    clueNumber: 6,
    clue: "URL suffix",
    index: [3, 1],
    answer: "COM",
  },
  {
    clueNumber: 7,
    clue: "Encryption method, for short",
    index: [3, 7],
    answer: "AES",
  },
];
